import { IModelBase } from '../../model';
import { ICollectionState } from './ICollectionState';

export const setLoadingCollectionState = <T extends IModelBase>(
  collection: ICollectionState<T>,
  loading: boolean
): void => {
  collection.loading = loading;
};
